import React from "react";
import { StyledPaddingDiv } from "./styled";

function PaddingDiv({ children }) {
  return <StyledPaddingDiv>{children}</StyledPaddingDiv>;
}

export default PaddingDiv;
